/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { UnityRootState } from "../../UnityAppStore";
import type { ResetIdentityPayload } from "../signIn.types";

export const selectRecoveryEmail = (state: UnityRootState): string =>
  state.signIn.recoveryEmail !== undefined ? state.signIn.recoveryEmail : "";

export const selectIsSendingResetLink = (state: UnityRootState): boolean =>
  state.signIn.isSendingResetLink !== undefined
    ? state.signIn.isSendingResetLink
    : false;

export const selectSendResetLinkError = (state: UnityRootState): string =>
  state.signIn.sendResetLinkError !== undefined
    ? state.signIn.sendResetLinkError
    : "";

export const selectIsResetTokenValidating = (state: UnityRootState): boolean =>
  state.signIn.isResetTokenValidating !== undefined
    ? state.signIn.isResetTokenValidating
    : false;

export const selectResetTokenValidationError = (
  state: UnityRootState
): string =>
  state.signIn.resetTokenValidationError !== undefined
    ? state.signIn.resetTokenValidationError
    : "";

export const selectResetIdentityPayload = (
  state: UnityRootState
): ResetIdentityPayload | null =>
  state.signIn.resetIdentityPayload !== undefined
    ? state.signIn.resetIdentityPayload
    : null;

export const selectIsUpdatingPassword = (state: UnityRootState): boolean =>
  state.signIn.isUpdatingPassword !== undefined
    ? state.signIn.isUpdatingPassword
    : false;

export const selectUpdatePasswordError = (state: UnityRootState): string =>
  state.signIn.updatePasswordError !== undefined
    ? state.signIn.updatePasswordError
    : "";

export const selectIsPasswordResetComplete = (
  state: UnityRootState
): boolean =>
  state.signIn.isPasswordResetComplete !== undefined
    ? state.signIn.isPasswordResetComplete
    : false;
